import { render, staticRenderFns } from "./NavbarDetails.vue?vue&type=template&id=5cb9481d&"
import script from "./NavbarDetails.vue?vue&type=script&lang=ts&"
export * from "./NavbarDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports